/*********************************************************************************
 1. Dependencies
 *********************************************************************************/

import styled from 'styled-components';


/*********************************************************************************
 2. Component
 *********************************************************************************/

export const StyledIcon = styled.i`
  stroke: currentColor;  
`;



// WEBPACK FOOTER //
// ./src/components/atoms/StyledIcon/index.js